import { useCallback } from "react"
import { graphql, useMutation } from "react-relay"
import { UpdateAppointmentReviewStatusInput } from "@/modules/waiting-room/services/__generated__/useUpdateAppointmentReviewStatusMutation.graphql"

const mutation = graphql`
  mutation useUpdateAppointmentReviewStatusMutation($input: UpdateAppointmentReviewStatusInput!) {
    updateAppointmentReviewStatus(input: $input) {
      appointment {
        reviewStatus
      }
    }
  }
`

export function useUpdateAppointmentReviewStatusMutation() {
  const [commit] = useMutation(mutation)

  return useCallback(
    (input: UpdateAppointmentReviewStatusInput, handleComplete?: () => void) => {
      commit({
        variables: { input },
        onCompleted: handleComplete,
      })
    },
    [commit],
  )
}
